import { ReactElement, useState } from 'react';
import { Button } from '@components';
import { FormType } from '@constants';
import styles from './FormSubmissionSuccessAlertContent.module.scss';

interface formSubmissionSuccessAlertContent {
  submissionNumberAlertInfo: string;
  email: string;
  hasEmailCopy: string;
  formType?: string;
}

const FormSubmissionSuccessAlertContent = ({ submissionNumberAlertInfo, email, hasEmailCopy, formType = '' }: formSubmissionSuccessAlertContent): ReactElement => {
  const [isCopied, setIsCopied] = useState('Copy');
  // utility function to copy text
  const copyToClipboard = (text: string) => {
    const textarea = document.createElement('textarea');
    textarea.innerText = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    textarea.remove();
    setIsCopied('Copied');
  };

  return (
    <div className={styles.submissionAlertInfoMsgContainer}>
      <div className={styles.submissionHeading}>
        { formType === FormType.FAMILYVIOLENCESCHEME
        ? (<span className={styles.bold}>The main obligation number you used to submit this application is:</span>)
        : (<span className={styles.bold}>Your submission number is:</span>)}
      </div>
      <hr />
      <div className={styles.submissionInfo}>
        <span className={styles.bold}>{` ${submissionNumberAlertInfo} `}</span>
        <Button onClick={() => copyToClipboard(submissionNumberAlertInfo)} color="transparent" size="small" className={styles.button}>
          <span className={styles.bold}>{isCopied}</span>
        </Button>
      </div>
      <hr />
      { formType === FormType.FAMILYVIOLENCESCHEME
        ? (
          <>
            <p>If you need to contact us, you can mention this number. We will send you confirmation that we’ve received your application by post or email.</p>
            <br />
            <p>If you included other obligation numbers in your application, we will consider these also.</p>
          </>
          )
        : (<p>Please make a note for your records.</p>)}
      <div className={styles.lineBreak} />
      {hasEmailCopy === 'true' && (
        <>
          <p>
            A copy of your completed application has been emailed to
            {` ${email}.`}
          </p>
          <div className={styles.lineBreak} />
          <p>If you don't receive it, please check your junk mail/spam folder.</p>
        </>
      )}
    </div>
  );
};

export default FormSubmissionSuccessAlertContent;
